unit ULogin;

interface

uses
  System.SysUtils, System.Classes, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection,
  XData.Web.Client, JS, WEBLib.ExtCtrls, Generics.Collections, WEBLib.Cookies,
  WEBLib.Login
//  {$IFDEF DEBUG}
  ,WEBLib.WebTools,
//  {$ENDIF},
  UErrorHandling, Vcl.Imaging.pngimage, XData.Web.Response, WEBLib.Actions,
  WEBLib.Buttons, WEBLib.WebCtrls, WEBLib.DropDown, WEBLib.Storage,
  System.StrUtils, System.DateUtils, WEBLib.JSON;

type
  TfrmLogin = class(TForm)
    edtUsermail: TEdit;
    edtPassword: TEdit;
    btnLogin: TButton;
    msgLoginMessage: TMessageDlg;
    imgUserIcon: TImageControl;
    lblLoginText: TLabel;
    imgLogo: TImageControl;
    divLogoImgContainer: THTMLDiv;
    divMainContainer: THTMLDiv;
    divCardContainer: THTMLDiv;
    divFormContainer: THTMLDiv;
    divUserIconContainer: THTMLDiv;
    divContentContainer: THTMLDiv;
    divCardBody: THTMLDiv;
    divOuterContainer: THTMLDiv;
    chkRememberLogin: TCheckBox;
    ssRememberLogin: TSessionStorage;
    btnPasswordLost: TButton;
    procedure btnLoginClick(Sender: TObject);
    procedure edtPasswordKeyPress(Sender: TObject; var Key: Char);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnPasswordLostClick(Sender: TObject);
  private
    [async]procedure CheckLogin; async;
    [async]procedure Login; async;
    [async]function LoginAsync: Boolean; async;
    [async]procedure AutoLoginAsync(AId:integer); async;
    [async]procedure SetAutoLogin; async;
    [async]function CheckAutoLogin: Boolean; async;
    [async]function FirstLogin : Boolean; async;
    [async]function PasswordReset : Boolean; async;
    [async]function CheckFirstLogin : Boolean; async;
    [async]function CheckPasswordReset : Boolean; async;
    procedure RemoveAutoLogin;
    procedure PasswordLost;
    [async]procedure SendPasswordReset(aEmail : String); async;
    function getAutoLogin: string;
    { Private declarations }
  published
  public
    { Public declarations }
    [async]procedure LogoutAsync(UserId: Integer); async;
  protected procedure LoadDFMValues; override; end;

var
  frmLogin: TfrmLogin;

implementation

{$R *.dfm}
uses
  UMain, UDataModule, UMainMenu, UFirstLogin, UHelper, UResources, UJSHelper;

// username: admin
// password: admin
// currently only the variables above work for a successful login
procedure TfrmLogin.AutoLoginAsync(AId:integer);
var
  LResponse: TXDataClientResponse;
  LResponseData, LTokens: TJSObject;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUserAuth.AccessToken',
        ['', AId])
      );

    if LResponse.StatusCode = 200 then
    begin
      LResponseData := TJSJSON.parseObject(LResponse.ResponseText);
      LTokens := TJSJSON.parseObject(TJSJSON.stringify(LResponseData.Properties['Tokens']));
      UDM.AccessToken := String(TJSObject(LTokens)['AccessToken']);
      UDM.UserMail := String(LResponseData.Properties['UserName']);
      UDM.UserID := Integer(LResponseData.Properties['UserID']);
      UDM.CustomerName := String(LResponseData.Properties['CustomerName']);
      UDM.CustomerID := Integer(LResponseData.Properties['CustomerID']);
      UDM.AdminRights := Boolean(LResponseData.Properties['AdminRights']);
      UDM.LogisticRights := Boolean(LResponseData.Properties['LogisticRights']);
      UDM.UserMail := String(LResponseData.Properties['Mail']);
//      UDM.LoginToken := String(LResponseData.Properties['LoginToken']);
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;

procedure TfrmLogin.btnLoginClick(Sender: TObject);
begin
  Login;
end;


procedure TfrmLogin.btnPasswordLostClick(Sender: TObject);
begin
  PasswordLost;
end;


function TfrmLogin.CheckAutoLogin: Boolean;
var
  lcookie, ltoken, lUserId: string;
  lcharArray : Array[0..0] of Char;
  LResponse: TXDataClientResponse;
begin
  Result:= false;
  lcookie := getAutoLogin;
  lcharArray[0] := '-';
  if lcookie = '' then
    exit
  else
  begin
    ltoken := SplitString(lcookie, '-')[0];
    lUserId := SplitString(lcookie, '-')[1];
    try
      LResponse :=
        await(
          TXDataClientResponse,
          UDM.XDataWebClient.RawInvokeAsync('IUserAuth.CheckLogin',
          [lUserId.ToInteger])
        );

      if LResponse.StatusCode = 200 then
      begin
        if (lToken = String(TJSObject(LResponse.Result)['value'])) then
        begin
          await(AutoLoginAsync(lUserId.ToInteger));
          Result := true;
        end;
      end
      else
      begin
        Result:= false;
      end;

      except
        on E: EXDataClientRequestException do
        begin
          TErrorHandling.DisplayServerError(E);
        end;
    end;
  end;
end;


function TfrmLogin.CheckFirstLogin: Boolean;
var
  LResponse: TXDataClientResponse;
begin
  Result := false;
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUserAuth.checkfirstlogin',
        [UDM.UserMail, UDM.PasswordToken])
      );

    if LResponse.StatusCode = 200 then
    begin
      if Boolean(TJSObject(LResponse.Result)['value']) then
        Result := true;
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmLogin.edtPasswordKeyPress(Sender: TObject; var Key: Char);
begin
  if Key = #13 then
  begin
    btnLogin.Click;
    Key := #0;
  end;
end;


function TfrmLogin.FirstLogin: Boolean;
var
  lform: TfrmFirstLogin;
begin
  if await(CheckFirstLogin) then
  begin
    if Assigned(lform) then
      lform.Close;
    lform := TfrmFirstLogin.CreateNew(divMainContainer.ElementID, nil);
    lForm.UserMail := UDM.UserMail;
    lform.FirstLogin := true;
  end;
end;


function TfrmLogin.getAutoLogin: string;
var
  Cookies: TCookies;
  Cookie: TCookie;
begin
  Result := '';
  Cookies := TCookies.Create;
  Try
    Cookies.GetCookies;
    Cookie := Cookies.Find(sCookie);
    if Assigned(Cookie) then
      Result := Cookie.Value;
  Finally
    Cookies.Free;
  End;
end;


procedure TfrmLogin.Login;
var
  lform: TfrmMainMenu;
begin

  if await(LoginAsync) then
  begin
    if Assigned(lform) and (UDM.AccessToken <> '') then
      lform.Close;
    lform := TfrmMainMenu.CreateNew(divMainContainer.ElementID, nil);
  end;
end;

procedure TfrmLogin.CheckLogin;
var
  lform: TfrmMainMenu;
begin
  if await(CheckAutoLogin) then
  begin
    if Assigned(lform) and (UDM.AccessToken <> '') then
      lform.Close;
    lform := TfrmMainMenu.CreateNew(divMainContainer.ElementID, nil);
  end;
end;


function TfrmLogin.CheckPasswordReset: Boolean;
var
  LResponse: TXDataClientResponse;
begin
  Result := false;
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUserAuth.checkPasswordReset',
        [UDM.UserMail, UDM.PasswordToken])
      );

    if LResponse.StatusCode = 200 then
    begin
      if Boolean(TJSObject(LResponse.Result)['value']) then
        Result := true;
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


function TfrmLogin.LoginAsync: Boolean;
var
  LResponse: TXDataClientResponse;
  LResponseData, LTokens: TJSObject;
begin
  if ((edtUsermail.Text = '') OR (edtPassword.Text = '' )) then
  begin
    if edtUsermail.Text = '' then
    begin
      edtUsermail.SetFocus;
      exit;
    end;
    if edtPassword.Text = '' then
    begin
      edtPassword.SetFocus;
    end;
    Result := false;
  end
  else
  begin
    try
      LResponse :=
        await(
          TXDataClientResponse,
          UDM.XDataWebClient.RawInvokeAsync('IUserAuth.AuthenticateUser',
          [edtUsermail.Text, edtpassword.Text])
        );

      THelper.DebugODS(LResponse.StatusCode.ToString + ' ' + LResponse.ResponseText);

      if LResponse.StatusCode = 200 then
      begin
        THelper.DebugODS('Create main menu and go to form');

        LResponseData := TJSJSON.parseObject(LResponse.ResponseText);
        LTokens := TJSJSON.parseObject(TJSJSON.stringify(LResponseData.Properties['Tokens']));
        UDM.AccessToken := String(TJSObject(LTokens)['AccessToken']);
        UDM.Usermail := String(LResponseData.Properties['Usermail']);
        UDM.UserID := Integer(LResponseData.Properties['UserID']);
        UDM.CustomerName := String(LResponseData.Properties['CustomerName']);
        UDM.CustomerID := Integer(LResponseData.Properties['CustomerID']);
        UDM.AdminRights := Boolean(LResponseData.Properties['AdminRights']);
        UDM.LogisticRights := Boolean(LResponseData.Properties['LogisticRights']);
        UDM.UserMail := String(LResponseData.Properties['Mail']);

        UDM.LoginToken := String(LResponseData.Properties['LoginToken']);

        if chkRememberLogin.Checked then
        begin
          SetAutoLogin;
        end;
        Result:= true;
      end
      else
      begin
        MessageDlg('Invalid credentials, please try again.', mtError, [mbAbort]);
        Result:= false;
      end;

      except
        on E: EXDataClientRequestException do
        begin
          TErrorHandling.DisplayServerError(E);
          Result:= false;
        end;
    end;
  end;
end;


procedure TfrmLogin.LogoutAsync(UserId: Integer);
var
  LResponse: TXDataClientResponse;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUserAuth.UserLogout',
        [UserId])
      );

    if LResponse.StatusCode = 200 then
    begin
      if Boolean(TJSObject(LResponse.Result)['value']) then
        RemoveAutoLogin;
    end;

    except
      on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmLogin.PasswordLost;
begin
  if (edtUsermail.Text <> '') then
  begin
    SendPasswordReset(edtUsermail.Text);
  end
  else
  begin
    MessageDlg('Bitte geben Sie oben Ihre E-Mail ein!', mtError, [mbAbort]);
  end;
end;


function TfrmLogin.PasswordReset: Boolean;
var
  lForm: TfrmFirstLogin;
begin
  if await(CheckPasswordReset) then
  begin
    if Assigned(lForm) then
      lForm.Close;
    lForm := TfrmFirstLogin.CreateNew(divMainContainer.ElementID, nil);
    lForm.UserMail := UDM.UserMail;
    lForm.FirstLogin := false;
  end
  else
  begin
    MessageDlg('Link ungültig!', mtError, [mbAbort]);
  end;
end;


procedure TfrmLogin.RemoveAutoLogin;
var
  browserCookies: TCookies;
begin
 browserCookies := TCookies.Create;
  try
    browserCookies.GetCookies;
    browserCookies.Delete(browserCookies.Find(sCookie));
    browserCookies.SetCookies;
  finally
    browserCookies.Free;
  end;
end;


procedure TfrmLogin.SendPasswordReset(aEmail : String);
var
  LResponse: TXDataClientResponse;
begin

  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUsers.ResetPassword',
        [aEmail])
      );

    if (LResponse.StatusCode = 204) then
    begin
      MessageDlg('Wir haben eine E-Mail zum zurücksetzen des Passwortes geschickt. Prüfen Sie Ihren Posteingang. Der Link ist für 24 Stunden gültig.', mtInformation, [mbOK]);
    end
    else
    begin
      MessageDlg('Passwort konnte nicht zurückgesetzt werden! Versuchen Sie es erneut.', mtError, [mbAbort]);
    end;

  except
    on E: EXDataClientRequestException do
    begin
      TErrorHandling.DisplayServerError(E);
    end;
  end;
end;


procedure TfrmLogin.SetAutoLogin;
var siteCookie: TCookie;
  browserCookies: TCookies;
begin
 browserCookies := TCookies.Create;
  try
    browserCookies.GetCookies;
    siteCookie := browserCookies.Find(sCookie);
    if Assigned(siteCookie) then
    begin
      siteCookie.Value := UDM.LoginToken + '-' + UDM.UserID.ToString;
      siteCookie.Expiry := (IncDay(Now,7));
    end
    else
    begin
      browserCookies.Add(sCookie, UDM.LoginToken + '-' + UDM.UserId.ToString, IncDay(Now,7));
    end;
    browserCookies.SetCookies;
  finally
    browserCookies.Free;
  end;
end;


procedure TfrmLogin.WebFormCreate(Sender: TObject);
begin
  // handling and displaying errors in browser console
  Application.OnError := TErrorhandling.AppError;
  Application.OnException := TErrorhandling.AppException;

  // disabling the annoying red alert boxes from the browser
  Application.ErrorType := TApplicationErrorType.aeSilent;

  {$IFDEF PAS2JS}
  asm
  var width575 = window.matchMedia("(max-width: 575px)");
  width575.addEventListener("change", function() {
    pas.UJSHelper.THTMLComponents.LangResize(width575);
  });

  if(width575.matches){
    pas.UJSHelper.THTMLComponents.LangResize(width575);
  }
  end;
  {$ENDIF}

end;


procedure TfrmLogin.WebFormShow(Sender: TObject);
var
  LandingPage : String;
begin
  {$IFNDEF WIN32}
    asm
    pas.UJSHelper.THTMLComponents.LanguageInit();
    pas.UJSHelper.THTMLComponents.LoginInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
  end;
  {$ENDIF}

  LandingPage := GetQueryParam('JumpToPage');

  if (LandingPage <> UDM.JumpToPage) then
  begin
    if (LandingPage = sPageOrdersMenu) then
    begin
      UDM.JumpTopage := LandingPage;
      UDM.OrderNr := GetQueryParam('Nr');
      UDM.Form := sPageLogin;
      CheckLogin;
    end
    else if (LandingPage = sPageFirstLogin) then
    begin
      UDM.JumpTopage := LandingPage;
      UDM.PasswordToken := GetQueryParam('Token');
      UDM.UserMail := GetQueryParam('Mail');
      FirstLogin;
    end
    else if (LandingPage = sPagePasswordReset) then
    begin
      UDM.JumpTopage := LandingPage;
      UDM.PasswordToken := GetQueryParam('Token');
      UDM.UserMail := GetQueryParam('Mail');
      PasswordReset;
    end;
  end;

  CheckLogin;
end;

procedure TfrmLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divOuterContainer := THTMLDiv.Create('wcIDOuterContainer');
  divMainContainer := THTMLDiv.Create('wcIDMainContainer');
  msgLoginMessage := TMessageDlg.Create(Self);
  divContentContainer := THTMLDiv.Create('wcIDContentContainer');
  divLogoImgContainer := THTMLDiv.Create('wcIDLogoImgContainer');
  imgLogo := TImageControl.Create('wcIDLogoImage');
  divCardContainer := THTMLDiv.Create('wcIDCardContainer');
  divCardBody := THTMLDiv.Create('wcIDCardBody');
  divFormContainer := THTMLDiv.Create('wcIDFormContainer');
  btnLogin := TButton.Create('wcIDLoginBtn');
  edtPassword := TEdit.Create('wcIDPasswordInput');
  edtUsermail := TEdit.Create('wcIDUsernameInput');
  chkRememberLogin := TCheckBox.Create('wcIDRememberLogin');
  btnPasswordLost := TButton.Create('wcIDPasswordLostBtn');
  divUserIconContainer := THTMLDiv.Create('wcIDUserIconContainer');
  imgUserIcon := TImageControl.Create('wcIDUserIcon');
  lblLoginText := TLabel.Create('wcIDLoginText');
  ssRememberLogin := TSessionStorage.Create(Self);

  divOuterContainer.BeforeLoadDFMValues;
  divMainContainer.BeforeLoadDFMValues;
  msgLoginMessage.BeforeLoadDFMValues;
  divContentContainer.BeforeLoadDFMValues;
  divLogoImgContainer.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  divCardContainer.BeforeLoadDFMValues;
  divCardBody.BeforeLoadDFMValues;
  divFormContainer.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  edtUsermail.BeforeLoadDFMValues;
  chkRememberLogin.BeforeLoadDFMValues;
  btnPasswordLost.BeforeLoadDFMValues;
  divUserIconContainer.BeforeLoadDFMValues;
  imgUserIcon.BeforeLoadDFMValues;
  lblLoginText.BeforeLoadDFMValues;
  ssRememberLogin.BeforeLoadDFMValues;
  try
    Name := 'frmLogin';
    Left := 574;
    Top := 325;
    Width := 889;
    Height := 772;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divOuterContainer.SetParentComponent(Self);
    divOuterContainer.Name := 'divOuterContainer';
    divOuterContainer.Left := 0;
    divOuterContainer.Top := 0;
    divOuterContainer.Width := 889;
    divOuterContainer.Height := 772;
    divOuterContainer.HeightStyle := ssAuto;
    divOuterContainer.WidthStyle := ssAuto;
    divOuterContainer.Align := alClient;
    divOuterContainer.ChildOrder := 1;
    divOuterContainer.ElementPosition := epIgnore;
    divOuterContainer.ElementFont := efCSS;
    divOuterContainer.Role := '';
    divMainContainer.SetParentComponent(divOuterContainer);
    divMainContainer.Name := 'divMainContainer';
    divMainContainer.Left := 0;
    divMainContainer.Top := 0;
    divMainContainer.Width := 889;
    divMainContainer.Height := 772;
    divMainContainer.HeightStyle := ssAuto;
    divMainContainer.WidthStyle := ssAuto;
    divMainContainer.Align := alClient;
    divMainContainer.ChildOrder := 1;
    divMainContainer.ElementPosition := epIgnore;
    divMainContainer.ElementFont := efCSS;
    divMainContainer.Role := '';
    msgLoginMessage.SetParentComponent(divMainContainer);
    msgLoginMessage.Name := 'msgLoginMessage';
    msgLoginMessage.Left := 76;
    msgLoginMessage.Top := 17;
    msgLoginMessage.Width := 24;
    msgLoginMessage.Height := 24;
    msgLoginMessage.Buttons := [];
    msgLoginMessage.Opacity := 0.600000000000000000;
    msgLoginMessage.ElementButtonClassName := 'btn';
    msgLoginMessage.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    msgLoginMessage.ElementTitleClassName := 'text-body';
    msgLoginMessage.ElementContentClassName := 'text-body';
    divContentContainer.SetParentComponent(divMainContainer);
    divContentContainer.Name := 'divContentContainer';
    divContentContainer.Left := 0;
    divContentContainer.Top := 0;
    divContentContainer.Width := 889;
    divContentContainer.Height := 772;
    divContentContainer.ElementClassName := 'col-xxl-4 col-xl-5 col-lg-6 col-md-8 col-sm-9 mx-auto';
    divContentContainer.HeightStyle := ssAuto;
    divContentContainer.WidthStyle := ssAuto;
    divContentContainer.Align := alClient;
    divContentContainer.ChildOrder := 3;
    divContentContainer.ElementPosition := epIgnore;
    divContentContainer.ElementFont := efCSS;
    divContentContainer.Role := '';
    divLogoImgContainer.SetParentComponent(divContentContainer);
    divLogoImgContainer.Name := 'divLogoImgContainer';
    divLogoImgContainer.Left := 0;
    divLogoImgContainer.Top := 0;
    divLogoImgContainer.Width := 889;
    divLogoImgContainer.Height := 89;
    divLogoImgContainer.ElementClassName := 'mb-5 mt-2 text-center';
    divLogoImgContainer.Align := alTop;
    divLogoImgContainer.ChildOrder := 1;
    divLogoImgContainer.ElementFont := efCSS;
    divLogoImgContainer.Role := '';
    imgLogo.SetParentComponent(divLogoImgContainer);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 334;
    imgLogo.Top := 0;
    imgLogo.Width := 229;
    imgLogo.Height := 89;
    imgLogo.ElementClassName := 'img-logo';
    imgLogo.HeightStyle := ssAuto;
    imgLogo.WidthStyle := ssAuto;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.ElementPosition := epIgnore;
    imgLogo.Picture.LoadFromFile('ULogin.divLogoImgContainer.imgLogo.Picture.png');
    divCardContainer.SetParentComponent(divContentContainer);
    divCardContainer.Name := 'divCardContainer';
    divCardContainer.Left := 262;
    divCardContainer.Top := 168;
    divCardContainer.Width := 379;
    divCardContainer.Height := 577;
    divCardContainer.ElementClassName := 'card border-0 shadow card-container mt-5';
    divCardContainer.HeightStyle := ssAuto;
    divCardContainer.WidthStyle := ssAuto;
    divCardContainer.ChildOrder := 1;
    divCardContainer.ElementPosition := epIgnore;
    divCardContainer.ElementFont := efCSS;
    divCardContainer.Role := '';
    divCardBody.SetParentComponent(divCardContainer);
    divCardBody.Name := 'divCardBody';
    divCardBody.Left := 22;
    divCardBody.Top := 16;
    divCardBody.Width := 339;
    divCardBody.Height := 537;
    divCardBody.ElementClassName := 'card-body wcCLLoginInner';
    divCardBody.HeightStyle := ssAuto;
    divCardBody.WidthStyle := ssAuto;
    divCardBody.ElementPosition := epIgnore;
    divCardBody.ElementFont := efCSS;
    divCardBody.Role := '';
    divFormContainer.SetParentComponent(divCardBody);
    divFormContainer.Name := 'divFormContainer';
    divFormContainer.Left := 46;
    divFormContainer.Top := 236;
    divFormContainer.Width := 257;
    divFormContainer.Height := 277;
    divFormContainer.ElementClassName := 'text-center';
    divFormContainer.HeightStyle := ssAuto;
    divFormContainer.WidthStyle := ssAuto;
    divFormContainer.ElementPosition := epIgnore;
    divFormContainer.ElementFont := efCSS;
    divFormContainer.Role := '';
    btnLogin.SetParentComponent(divFormContainer);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 16;
    btnLogin.Top := 135;
    btnLogin.Width := 225;
    btnLogin.Height := 40;
    btnLogin.Caption := 'Login';
    btnLogin.ChildOrder := 13;
    btnLogin.ElementClassName := 'btn btn-primary wcCLLoginBtn mb-3';
    btnLogin.ElementPosition := epRelative;
    btnLogin.Font.Charset := DEFAULT_CHARSET;
    btnLogin.Font.Color := clWindowText;
    btnLogin.Font.Height := -19;
    btnLogin.Font.Name := 'Tahoma';
    btnLogin.Font.Style := [];
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.ParentFont := False;
    btnLogin.TabOrder := 2;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    edtPassword.SetParentComponent(divFormContainer);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 16;
    edtPassword.Top := 77;
    edtPassword.Width := 225;
    edtPassword.Height := 36;
    edtPassword.AutoCompletion := acCurrentPassword;
    edtPassword.ChildOrder := 11;
    edtPassword.ElementClassName := 'wcCLFormControl py-2 mb-5';
    edtPassword.ElementPosition := epRelative;
    edtPassword.Font.Charset := DEFAULT_CHARSET;
    edtPassword.Font.Color := clWindowText;
    edtPassword.Font.Height := -27;
    edtPassword.Font.Name := 'Tahoma';
    edtPassword.Font.Style := [];
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.ParentFont := False;
    edtPassword.PasswordChar := #12;
    edtPassword.TabOrder := 1;
    edtPassword.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword, Self, 'OnKeyPress', 'edtPasswordKeyPress');
    edtUsermail.SetParentComponent(divFormContainer);
    edtUsermail.Name := 'edtUsermail';
    edtUsermail.Left := 16;
    edtUsermail.Top := 35;
    edtUsermail.Width := 225;
    edtUsermail.Height := 36;
    edtUsermail.AutoCompletion := acUserName;
    edtUsermail.ChildOrder := 9;
    edtUsermail.ElementClassName := 'wcCLFormControl py-2 mb-4 mt-4';
    edtUsermail.ElementPosition := epRelative;
    edtUsermail.Font.Charset := DEFAULT_CHARSET;
    edtUsermail.Font.Color := clWindowText;
    edtUsermail.Font.Height := -27;
    edtUsermail.Font.Name := 'Tahoma';
    edtUsermail.Font.Style := [];
    edtUsermail.HeightPercent := 100.000000000000000000;
    edtUsermail.ParentFont := False;
    edtUsermail.RequiredText := 'E-Mail*';
    edtUsermail.WidthPercent := 100.000000000000000000;
    chkRememberLogin.SetParentComponent(divFormContainer);
    chkRememberLogin.Name := 'chkRememberLogin';
    chkRememberLogin.Left := 128;
    chkRememberLogin.Top := 183;
    chkRememberLogin.Width := 113;
    chkRememberLogin.Height := 22;
    chkRememberLogin.Caption := 'Remember me';
    chkRememberLogin.ChildOrder := 3;
    chkRememberLogin.ElementClassName := 'custom-control custom-checkbox';
    chkRememberLogin.ElementButtonClassName := 'custom-control-input';
    chkRememberLogin.ElementLabelClassName := 'custom-control-label';
    chkRememberLogin.ElementFont := efCSS;
    chkRememberLogin.ElementPosition := epIgnore;
    chkRememberLogin.HeightStyle := ssAuto;
    chkRememberLogin.HeightPercent := 100.000000000000000000;
    chkRememberLogin.TabOrder := 3;
    chkRememberLogin.WidthStyle := ssAuto;
    chkRememberLogin.WidthPercent := 100.000000000000000000;
    btnPasswordLost.SetParentComponent(divFormContainer);
    btnPasswordLost.Name := 'btnPasswordLost';
    btnPasswordLost.Left := 16;
    btnPasswordLost.Top := 227;
    btnPasswordLost.Width := 225;
    btnPasswordLost.Height := 40;
    btnPasswordLost.Anchors := [akLeft,akBottom];
    btnPasswordLost.Caption := 'Passwort vergessen';
    btnPasswordLost.ChildOrder := 13;
    btnPasswordLost.ElementClassName := 'btn btn-primary wcCLPasswordLostBtn mb-3';
    btnPasswordLost.ElementFont := efCSS;
    btnPasswordLost.ElementPosition := epRelative;
    btnPasswordLost.Font.Charset := DEFAULT_CHARSET;
    btnPasswordLost.Font.Color := clWindowText;
    btnPasswordLost.Font.Height := -19;
    btnPasswordLost.Font.Name := 'Tahoma';
    btnPasswordLost.Font.Style := [];
    btnPasswordLost.HeightStyle := ssAuto;
    btnPasswordLost.HeightPercent := 100.000000000000000000;
    btnPasswordLost.ParentFont := False;
    btnPasswordLost.TabOrder := 2;
    btnPasswordLost.WidthStyle := ssAuto;
    btnPasswordLost.WidthPercent := 100.000000000000000000;
    SetEvent(btnPasswordLost, Self, 'OnClick', 'btnPasswordLostClick');
    divUserIconContainer.SetParentComponent(divCardBody);
    divUserIconContainer.Name := 'divUserIconContainer';
    divUserIconContainer.Left := 46;
    divUserIconContainer.Top := 30;
    divUserIconContainer.Width := 257;
    divUserIconContainer.Height := 187;
    divUserIconContainer.ElementClassName := 'mb-3 mt-3 text-center';
    divUserIconContainer.HeightStyle := ssAuto;
    divUserIconContainer.WidthStyle := ssAuto;
    divUserIconContainer.ChildOrder := 1;
    divUserIconContainer.ElementPosition := epIgnore;
    divUserIconContainer.ElementFont := efCSS;
    divUserIconContainer.Role := '';
    imgUserIcon.SetParentComponent(divUserIconContainer);
    imgUserIcon.Name := 'imgUserIcon';
    imgUserIcon.Left := 73;
    imgUserIcon.Top := 24;
    imgUserIcon.Width := 99;
    imgUserIcon.Height := 95;
    imgUserIcon.ElementClassName := 'wcCLUserIcon mb-3';
    imgUserIcon.HeightStyle := ssAuto;
    imgUserIcon.WidthStyle := ssAuto;
    imgUserIcon.HeightPercent := 100.000000000000000000;
    imgUserIcon.WidthPercent := 100.000000000000000000;
    imgUserIcon.Anchors := [];
    imgUserIcon.ChildOrder := 4;
    imgUserIcon.ElementPosition := epRelative;
    imgUserIcon.Picture.LoadFromFile('ULogin.divUserIconContainer.imgUserIcon.Picture.png');
    lblLoginText.SetParentComponent(divUserIconContainer);
    lblLoginText.Name := 'lblLoginText';
    lblLoginText.Left := 22;
    lblLoginText.Top := 145;
    lblLoginText.Width := 214;
    lblLoginText.Height := 39;
    lblLoginText.Caption := 'Bitte anmelden';
    lblLoginText.ChildOrder := 6;
    lblLoginText.ElementClassName := 'text-center wcCLLoginText';
    lblLoginText.ElementPosition := epRelative;
    lblLoginText.Font.Charset := DEFAULT_CHARSET;
    lblLoginText.Font.Color := clBlack;
    lblLoginText.Font.Height := -32;
    lblLoginText.Font.Name := 'Tahoma';
    lblLoginText.Font.Style := [];
    lblLoginText.HeightStyle := ssAuto;
    lblLoginText.HeightPercent := 100.000000000000000000;
    lblLoginText.ParentFont := False;
    lblLoginText.WidthPercent := 100.000000000000000000;
    ssRememberLogin.SetParentComponent(Self);
    ssRememberLogin.Name := 'ssRememberLogin';
    ssRememberLogin.Left := 808;
    ssRememberLogin.Top := 352;
  finally
    divOuterContainer.AfterLoadDFMValues;
    divMainContainer.AfterLoadDFMValues;
    msgLoginMessage.AfterLoadDFMValues;
    divContentContainer.AfterLoadDFMValues;
    divLogoImgContainer.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    divCardContainer.AfterLoadDFMValues;
    divCardBody.AfterLoadDFMValues;
    divFormContainer.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    edtUsermail.AfterLoadDFMValues;
    chkRememberLogin.AfterLoadDFMValues;
    btnPasswordLost.AfterLoadDFMValues;
    divUserIconContainer.AfterLoadDFMValues;
    imgUserIcon.AfterLoadDFMValues;
    lblLoginText.AfterLoadDFMValues;
    ssRememberLogin.AfterLoadDFMValues;
  end;
end;

initialization
  RegisterClass(TfrmLogin);

end.
